"use strict";
(function(){
    /**
     * Работа с фоном страниц
     */
    var self = Fotobook.pageBackground = {
        /**
         * Диалог изменения фона страницы
         *
         * @param pageBgParams
         */
        changePageBackgroundDialog(pageBgParams) {
            return Fotobook.pageLayout.changeDialog({
                title: t('photobook-js-applyElementDialogTitle', {
                    element: t('photobook-js-background'),
                }),
                content: t('photobook-js-applyElement', {
                    elementName: t('photobook-js-background'),
                }),
                all_condition: Fotobook.book.cover.foto_clipart ? Fotobook.book.select_foto_bg_filter : Fotobook.book.select_bg_filter,
            }).then((data) => {
                self.selectPageBackground(data.pages, data.button, pageBgParams);
            }).catch(() => {});
        },

        /**
         * Изменение фона страницы
         *
         * @param $pages
         * @param button
         * @param pageBgParams
         */
        selectPageBackground($pages, button, pageBgParams) {
            $pages = Fotobook.filterEmptyPages($pages);

            if (!$pages.length || ($pages.filter('.cover').length && !Fotobook.book.cover.foto_clipart) || $pages.filter('.flyleaf-page').length) {
                Fotobook.notification.showWarning(t('photobook-js-messageBackgroundForPages'));
                return;
            }

            const containers = {};
            const attrs = {
                ...pageBgParams,
            };

            if (button === 'both' && $pages.length === 2) {
                attrs.foto_position = Fotobook.FotoPosition.HALF;
                attrs.mask_id = Number($pages.find('.bg').find('.mask').attr('data-id')) || 0;
            } else {
                attrs.foto_position = Fotobook.FotoPosition.FULL;
            }

            $pages.find('.bg-content').each(function(){
                const id = Number(this.getAttribute('data-id'));

                if (id) {
                    containers[id] = attrs;
                }
            });

            if ($pages.length === 1) {
                Fotobook.book.getAdjacentPage($pages).find('.bg-content').each(function () {
                    const id = Number(this.getAttribute('data-id'));

                    if (id) {
                        containers[id] = {
                            foto_position: Fotobook.FotoPosition.FULL,
                        };
                    }
                });
            }
            Fotobook.containers.changeContainerAttrs(containers);
        },
    };

})();
